<template>
  <footer class="vocab footer">
    <!-- TODO -->
  </footer>
</template>

<script>
  /**
   * ### Footer concludes the page.
   *
   * The footer displays information about the site such as its developers and
   * maintainers as well as licensing information.
   */
  export default {
    name: 'Footer'
  }
</script>
